import React from 'react';
import { CarIcon, Trash2Icon } from 'lucide-react';
import { FamilyEvent } from '../../types/family';
import { useAppState } from '../../contexts/AppStateContext';
import { eventTypeLabels, sourceLabels } from '../../data/labels';
import { namesOf } from '../../utils/members';
import { formatDayLabel } from '../../utils/time';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { Field } from '../ui/Form';
export function EventSheet({
  eventId,
  onClose
}: {
  eventId: string | null;
  onClose: () => void;
}) {
  const {
    family,
    activeMembers,
    viewer,
    isAdmin,
    setEventTransport,
    deleteEvent
  } = useAppState();
  const e: FamilyEvent | undefined = family.events.find(x => x.id === eventId);
  const canDelete = e && e.source === 'app' && (isAdmin || e.createdBy === viewer.id);
  const facts: [string, string][] = e ? [['Kdaj', `${formatDayLabel(e.date)}, ${e.start}${e.end ? `–${e.end}` : ''}`], ['Vrsta', eventTypeLabels[e.type]], ['Kdo', e.participantIds.length ? namesOf(family, e.participantIds) : 'Vsa družina'], ['Ponavljanje', e.repeat ?? 'Enkratno'], ['Opomnik', e.reminder ?? 'Privzeto'], ['Vir', `${sourceLabels[e.source]}${e.source !== 'app' ? ' · samo za branje (vzorec)' : ''}`]] : [];
  const select = (label: string, value: string | undefined, key: 'driverId' | 'pickupId') => <Field label={label} data-id="element-58" data-mp="3gh589i4nkziy">
      {id => <select id={id} className="field" value={value ?? ''} onChange={ev => e && setEventTransport(e.id, {
      [key]: ev.target.value || undefined
    })} data-id="element-59" data-mp="3gig856uz9n4s">
          <option value="" data-id="element-60" data-mp="37hi44okjhfm7">Še nihče</option>
          {activeMembers.map(m => <option key={m.id} value={m.id} data-id="element-61" data-mp="3biac7ehodegw">
              {m.name}
            </option>)}
        </select>}
    </Field>;
  return <Sheet open={Boolean(e)} onClose={onClose} title={e?.title ?? ''} subtitle={e ? eventTypeLabels[e.type] : undefined} footer={canDelete ? <Button variant="secondary" className="w-full" onClick={() => {
    if (e) deleteEvent(e.id);
    onClose();
  }} data-id="element-63" data-mp="6jd22c8hmhvt">
            <Trash2Icon className="h-4 w-4" aria-hidden="true" data-id="element-64" data-mp="3syy1954a5xx7" /> Izbriši dogodek
          </Button> : undefined} data-id="element-62" data-mp="1w08mm7kz0xnj">
      {e && <div className="space-y-4" data-id="element-65" data-mp="3jzksyfrw7fe2">
          <dl className="divide-y divide-line rounded-2xl border-[1.5px] border-line" data-id="element-66" data-mp="3k0m2gft9ftto">
            {facts.map(([k, v]) => <div key={k} className="grid grid-cols-[104px_1fr] gap-3 px-3 py-2.5 text-sm" data-id="element-67" data-mp="3ez6henr31nba">
                <dt className="font-semibold text-muted" data-id="element-68" data-mp="3a1wtxdn97lq3">{k}</dt>
                <dd className="first-letter:uppercase" data-id="element-69" data-mp="3533hzpnm82s1">{v}</dd>
              </div>)}
          </dl>
          <div className="rounded-2xl bg-info-soft p-3" data-id="element-70" data-mp="188ywt5mg26zc">
            <p className="mb-2 flex items-center gap-2 text-sm font-bold text-info-ink" data-id="element-71" data-mp="13axewo0r8dpg">
              <CarIcon className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="13947h6ibhpge" /> Prevoz
            </p>
            <div className="grid grid-cols-2 gap-3" data-id="element-73" data-mp="1bpv2sh3oejus">
              {select('Kdo pelje', e.driverId, 'driverId')}
              {select('Kdo pride iskat', e.pickupId, 'pickupId')}
            </div>
            {!e.driverId && <Button size="sm" className="mt-3" onClick={() => setEventTransport(e.id, {
          driverId: viewer.id
        })} data-id="element-74" data-mp="1pj2us9vo5hd0">
                Prevzamem prevoz
              </Button>}
          </div>
          <p className="text-xs text-muted" data-id="element-75" data-mp="wuf41ys5hzs2">Vidnost dogodka ne pomeni pravice urejanja tujih vsebin. Uvoženim dogodkom lahko dodaš le prevoz.</p>
        </div>}
    </Sheet>;
}